import { render } from "./RoundSizesList.vue?vue&type=template&id=498d0736&scoped=true"
import script from "./RoundSizesList.vue?vue&type=script&lang=js"
export * from "./RoundSizesList.vue?vue&type=script&lang=js"

import "./RoundSizesList.vue?vue&type=style&index=0&id=498d0736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498d0736"]])

export default __exports__